import { writable, get } from "svelte/store";
import { LocalStorage } from "$/services/LocalStorage.js";
export var TopicViewTypes;
(function (TopicViewTypes) {
    TopicViewTypes["BOARD"] = "board";
    TopicViewTypes["GRID"] = "grid";
    TopicViewTypes["LIST"] = "list";
})(TopicViewTypes || (TopicViewTypes = {}));
const TOPIC_VIEW_PREFERENCES_KEY = "topicViewPreferences";
const store = () => {
    const { subscribe, set, update } = writable([]);
    LocalStorage.get(TOPIC_VIEW_PREFERENCES_KEY).then((data) => {
        const storedData = data !== null && data !== void 0 ? data : [];
        set(storedData);
    });
    return {
        subscribe,
        set,
        update,
        init: async () => {
            var _a;
            const storedData = (_a = LocalStorage.get(TOPIC_VIEW_PREFERENCES_KEY)) !== null && _a !== void 0 ? _a : [];
            set(storedData);
            return storedData;
        },
        selectedViewByTopicId: (topicId) => {
            var _a;
            const state = (_a = get(TopicViewStore)) !== null && _a !== void 0 ? _a : [];
            const view = state.find((view) => view.id === topicId);
            return (view === null || view === void 0 ? void 0 : view.view) || TopicViewTypes.BOARD;
        },
    };
};
export const TopicViewStore = store();
TopicViewStore.subscribe((value) => {
    LocalStorage.set(TOPIC_VIEW_PREFERENCES_KEY, value);
});
